import { render, staticRenderFns } from "./Operacao.vue?vue&type=template&id=2f56883d&lang=pug"
import script from "./Operacao.vue?vue&type=script&lang=js"
export * from "./Operacao.vue?vue&type=script&lang=js"
import style0 from "./Operacao.vue?vue&type=style&index=0&id=2f56883d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports